 enum GroupStatusEnum{
    AllSelected,
    NoneSelected,
    Mixed
}
export default GroupStatusEnum;